export default __webpack_public_path__ + "static/media/avatar_26.31836510.png";